// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import axios from 'axios'
import App from './App'
import router from './router'
import IPA from 'ipa.js'
import { Autocomplete } from 'element-ui'
import logo from '@/utils/texlogo'

axios.defaults.baseURL = process.isProduction ? '/ipa-document' : '';

window.IPA = IPA;
Vue.config.productionTip = false

Vue.component(Autocomplete.name, Autocomplete)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})

console.log(logo)


// WEBPACK FOOTER //
// ./src/main.js